export const printTranslations = {
  en: {
    itinerary: 'Itinerary', time: 'Time', details: 'Place & details', category: 'Category',
    duration: 'Duration', cost: 'Cost', emptyDay: 'No planned stops for this day.',
    destination: 'Destination', dates: 'Dates', currency: 'Base currency',
    action: 'Print / save as PDF',
  },
  tr: {
    itinerary: 'Gezi planı', time: 'Saat', details: 'Yer ve ayrıntılar', category: 'Kategori',
    duration: 'Süre', cost: 'Maliyet', emptyDay: 'Bu gün için planlanmış durak yok.',
    destination: 'Varış noktası', dates: 'Tarihler', currency: 'Ana para birimi',
    action: 'Yazdır / PDF olarak kaydet',
  },
  sv: {
    itinerary: 'Resplan', time: 'Tid', details: 'Plats och detaljer', category: 'Kategori',
    duration: 'Längd', cost: 'Kostnad', emptyDay: 'Inga planerade stopp för den här dagen.',
    destination: 'Destination', dates: 'Datum', currency: 'Basvaluta',
    action: 'Skriv ut / spara som PDF',
  },
};
